import Router from 'next/router';
import NProgress from 'nprogress';

import PageProgressBar from './PageProgressBar.styles';

NProgress.configure({ showSpinner: false, trickleSpeed: 700 });

const startProgressBar = () => NProgress.start();
const stropProgressBar = () => NProgress.done();

Router.events.on('routeChangeStart', startProgressBar);
Router.events.on('routeChangeComplete', stropProgressBar);
Router.events.on('routeChangeError', stropProgressBar);
Router.events.on('hashChangeComplete', stropProgressBar);

export default PageProgressBar;
